import { getCookiePreferences } from '/business/shared/functions/cookiePreferences';

type HotjarArgument = string | number | boolean | null | undefined;
type HotjarFunction = ((...args: HotjarArgument[]) => void) & {
  q?: HotjarArgument[][];
};

declare global {
  interface Window {
    hj?: HotjarFunction;
    _hjSettings?: {
      hjid: string;
      hjsv: number;
    };
  }
}

function initialize(tracking_uid: string) {
  if (!getCookiePreferences().hotjar) {
    return null;
  }

  window.hj =
    window.hj ||
    function (...args: HotjarArgument[]) {
      if (window.hj) {
        window.hj.q = window.hj.q || [];
        window.hj.q.push(args);
      }
    };
  window._hjSettings = { hjid: tracking_uid, hjsv: 6 };
  const head = document.getElementsByTagName('head')[0];
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://static.hotjar.com/c/hotjar-${window._hjSettings.hjid}.js?sv=${window._hjSettings.hjsv}`;
  head.appendChild(script);
}

function trigger(name: string) {
  if (!getCookiePreferences().hotjar) {
    return null;
  }
  window.hj =
    window.hj ||
    function (...args: HotjarArgument[]) {
      if (window.hj) {
        window.hj.q = window.hj.q || [];
        window.hj.q.push(args);
      }
    };
  window.hj('trigger', name);
}

export default {
  initialize,
  trigger,
};
